import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { genfunction } from 'helpers'
import CancelIcon from '@material-ui/icons/Cancel'
import {
    Card, CardContent, CardHeader, IconButton,
    Table, TableBody, TableCell, TableRow, Hidden,
    Typography
} from '@material-ui/core';

import { NumberSpinner } from '../../../components/InputControls'
import { withRouter } from 'react-router'
import ErrorHandling from '../../../components/ErrorHandling/ErrorHandling';

const useStyles = makeStyles(theme => ({
    root: {},
    tourheaderbox: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.primary.contrastText
    },
    tourheadertext: {
        marginTop: "8px"
    },
    labelbold: {
        fontWeight: "bold",
        fontSize: "18px"
    },
    tablecell: {
        padding: "5px",
        alignSelf: ""
    }
}));

const OrderItemsCard = props => {

    const { products } = props;
    const [errorMsg, seterrorMsg] = useState("");
    const classes = useStyles();

    const changeQuantityHandler = (reference, value) => {
        props.changeQuantityHandler(reference, value);
    }

    const removeclickhandler = (ProductID) => {
        props.removeclickhandler(ProductID);
    }

    const errorcancelhandle = () => {
        seterrorMsg("");
    }

    const getProductOptions = (product) => {
        if (product.Options) {

            let productWithOptions = product.Options.filter(x => x.Products && x.Products.length > 0 && x.Products.find(y => y.IsSelected == true) != undefined);
            if (productWithOptions && productWithOptions.length > 0) {
                return (
                    productWithOptions.map(option => {
                        return (
                            option.Products.map(opproduct => {
                                return (
                                    opproduct.IsSelected ?
                                        <Typography variant='subtitle2'>
                                            {genfunction.replaceEscapeCharacters(opproduct.ProductName)}
                                        </Typography> : ""
                                )
                            }))
                    })
                );
            }
        }

        return "";
    }

    const getTotalAmount = () => {
        let amount = {
            subtotal: 0,
            tax: 0,
            total: 0,
        }

        let foodAmount = genfunction.getOrderProductsTotalPrice(products);
        amount.subtotal += foodAmount.subtotal;
        amount.tax += foodAmount.tax;
        amount.total += foodAmount.total;

        return amount;
    }
    return (
        <Card
            className={classes.root}
        >
            <CardHeader className={classes.tourheaderbox}
                title={"Order"}
                titleTypographyProps={{ color: "inherit" }}
            />
            <CardContent>
                <ErrorHandling msg={errorMsg} open={errorMsg != ""} handleclose={errorcancelhandle} />
                <Table size="small" className={classes.table} aria-label="spanning table">
                    <TableBody>
                        {products.map(product => (
                            <TableRow key={product.ProductID}>
                                <TableCell className={classes.tablecell} align="left">
                                    <IconButton
                                        edge="end"
                                        size="small"
                                        onClick={() => removeclickhandler(product)}
                                    >
                                        <CancelIcon color={"error"} />
                                    </IconButton>
                                </TableCell>
                                <TableCell className={classes.tablecell}>
                                    <Typography variant='h6'>{genfunction.replaceEscapeCharacters(product.ProductName)}</Typography>
                                    {getProductOptions(product)}
                                </TableCell>
                                <TableCell className={classes.tablecell} align="right">
                                    <TableCell className={classes.tablecell} align="right">{product.Quantity}</TableCell>
                                </TableCell>
                                <Hidden smDown>
                                    <TableCell className={classes.tablecell} align="right">{genfunction.ccyFormat(genfunction.getOrderProductsTotalPrice([product]).price)}</TableCell>
                                    <TableCell className={classes.tablecell} align="right">{genfunction.ccyFormat(genfunction.getOrderProductsTotalPrice([product]).subtotal)}</TableCell>
                                </Hidden>
                                <Hidden smUp>
                                    <TableCell className={classes.tablecell} colSpan={2} align="right">{genfunction.ccyFormat(genfunction.getOrderProductsTotalPrice([product]).subtotal)}</TableCell>
                                </Hidden>
                            </TableRow>
                        ))}

                        <TableRow>
                            <TableCell className={classes.tablecell} colSpan={2} />
                            <TableCell className={classes.tablecell} colSpan={1}>Subtotal</TableCell>
                            <TableCell className={classes.tablecell} colSpan={2} align="right">{genfunction.ccyFormat(getTotalAmount().subtotal)}</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell className={classes.tablecell} colSpan={2} />
                            <TableCell className={classes.tablecell} colSpan={1}>Tax</TableCell>
                            <TableCell className={classes.tablecell} colSpan={2} align="right">{genfunction.ccyFormat(getTotalAmount().tax)}</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell className={classes.tablecell} colSpan={2} />
                            <TableCell className={classes.labelbold + " " + classes.tablecell} colSpan={1}>Total</TableCell>
                            <TableCell className={classes.labelbold + " " + classes.tablecell} colSpan={2} align="right">{genfunction.ccyFormat(getTotalAmount().total)}</TableCell>
                        </TableRow>

                    </TableBody>
                </Table>
            </CardContent>
        </Card>
    );
};

OrderItemsCard.propTypes = {
    products: PropTypes.array.isRequired,
    removeclickhandler: PropTypes.func
};

export default withRouter(OrderItemsCard);
